export default __webpack_public_path__ + "static/media/banner.c1774e52.svg";